import styled, { css, keyframes } from 'styled-components';

const fadeIn = keyframes`
  from {
    opacity: 0;
    margin-top: -5px;
  } to {
    opacity: 1;
    margin-top: 0;
  }
`;

export const LabelFormWrapper = styled.form`
  position: relative;
`;

export const DeleteIcon = styled.div`
  display: none;
  margin-left: 10px;
  color: ${({ theme }) => theme.baseBlue.a6};
  cursor: pointer;
  &:hover {
    color: ${({ theme }) => theme.red.a10};
  }
`;

export const LabelsWrapper = styled.div<{ $inList?: boolean }>`
  display: flex;
  align-items: center;
  padding: 5px;
  animation: ${({ $inList }) =>
    $inList
      ? 'none'
      : css`
          ${fadeIn} 150ms ease-in
        `};
  &:hover {
    ${DeleteIcon} {
      display: block;
    }
  }
`;

export const FormTitle = styled.span.attrs({ className: 'hl3' })``;
export const LabelSearch = styled.div`
  margin-top: 30px;
  background-color: ${({ theme }) => theme.white.a10};
  border-radius: 5px;
  border: 1px solid ${({ theme }) => theme.baseBlue.a3};
  display: flex;
  align-items: center;
  padding: 5px 10px;
  min-height: 60px;
`;

export const LabelSuggestionList = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  margin-top: 30px;
  height: 218px;
  overflow: auto;
`;

export const CreationHeader = styled.span.attrs({ className: 'button_text' })`
  padding: 10px 0;
`;

export const ButtonSection = styled.div`
  border-top: 1px solid ${({ theme }) => theme.black.a1};
  padding: 30px;
  display: flex;
  justify-content: flex-end;
  margin: 0 -30px -30px -30px;
  > button {
    margin-left: 10px;
  }
`;
